import React from 'react';
import { Checkbox } from '@mui/material';
import { CustomCheckedIcon, CustomIcon } from './styles';

interface CustomCheckBoxProps {
  value: string;
  checked: boolean;
  setValue: (value: string) => void;
}

const CustomCheckBoxV2: React.FC<CustomCheckBoxProps> = ({ value, checked, setValue }) => {
  const handleChange = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    setValue(value);
  };

  return <Checkbox icon={<CustomIcon />} checkedIcon={<CustomCheckedIcon />} checked={checked} onClick={handleChange} />;
};

export default React.memo(CustomCheckBoxV2);
